import React from 'react';
import { Building2, Users, CheckCircle2, XCircle, TrendingUp, UserX } from 'lucide-react';
import { StatCard } from '../../../../shared/components/cards/StatCard';
import type { StatCardProps } from '../../../../shared/components/cards/StatCard';
import type { EntityRow, MetricMode } from './types';

interface AggSummaryCardsProps {
  row: EntityRow;
  label: string;
  metricMode: MetricMode;
}

const AggSummaryCards: React.FC<AggSummaryCardsProps> = function ({ row, label, metricMode }) {
  function pct(n: number) {
    return row.totalAppeared > 0 ? ((n / row.totalAppeared) * 100).toFixed(1) : '0.0';
  }

  const cards: Array<Pick<StatCardProps, 'title' | 'value' | 'icon' | 'color'> & { subtitle?: string }> = [
    {
      title: 'KVs (' + label + ')',
      value: String(row.count ?? 1),
      icon: <Building2 className="w-5 h-5" />,
      color: 'purple',
    },
    {
      title: 'Total Students',
      value: row.totalAppeared.toLocaleString(),
      icon: <Users className="w-5 h-5" />,
      color: 'blue',
    },
  ];
  if (metricMode !== 'pi') {
    cards.push(
      {
        title: 'Pass %',
        value: row.passPercentage + '%',
        subtitle: row.totalPassed.toLocaleString() + ' passed',
        icon: <CheckCircle2 className="w-5 h-5" />,
        color: 'green',
      },
      {
        title: 'Compartment',
        value: row.totalCompartment.toLocaleString(),
        subtitle: pct(row.totalCompartment) + '%',
        icon: <XCircle className="w-5 h-5" />,
        color: 'orange',
      },
      {
        title: 'Absent',
        value: row.totalAbsent.toLocaleString(),
        subtitle: pct(row.totalAbsent) + '%',
        icon: <UserX className="w-5 h-5" />,
        color: 'blue',
      },
    );
  }
  if (metricMode !== 'passStats') {
    cards.push({
      title: 'Perf. Index',
      value: row.performanceIndex + '%',
      icon: <TrendingUp className="w-5 h-5" />,
      color: 'pink',
    });
  }
  return (
    <div className="grid gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {cards.map(function (c) {
        return (
          <StatCard
            key={c.title}
            title={c.title}
            value={c.value}
            subtitle={(c as any).subtitle}
            icon={c.icon}
            color={c.color}
          />
        );
      })}
    </div>
  );
};

export default AggSummaryCards;
